import React from "react";
import "./ColorButtons.css"

function ColorButtons({ modalData, setModalData }) {

  const handleCircleClick = (index) => {
    let type = "red";

    // Logic to match standard color-prediction game rules:
    if (index === "Violet") {
      type = "violet";
    } else if (index === "Green") {
      type = "green";
    } else {
      type = "red";
    }

    setModalData({
      ...modalData,
      open: true,
      value: index,
      type: type,
      bet_type: "color",
    });
  };
  return (
    <div className="color_buttons">
      <button className="green_btn color_btn_holder" onClick={() => handleCircleClick("Green")}>Green</button>
      <button className="violet_btn color_btn_holder" onClick={() => handleCircleClick("Violet")}>Violet</button>
      <button className="red_btn color_btn_holder" onClick={() => handleCircleClick("Red")}>Red</button>
    </div>
  );
}

export default ColorButtons;